<template>
  <div>
    <el-row class="search-add" :gutter="10">
      <el-col :span="4">
        <el-input placeholder="机构名称" v-model="name"></el-input>
      </el-col>
      <el-col :span="4">
        <el-input placeholder="手机号" v-model="mobile"></el-input>
      </el-col>
      <el-col :span="14">
        <el-button type="primary" icon="el-icon-search" @click="search"
          >搜索</el-button
        >
      </el-col>
      <el-col :span="2">
        <router-link to="./add">
          <el-button type="success">新增</el-button>
        </router-link>
      </el-col>
    </el-row>

    <el-table :data="data" border stripe style="width: 100%">
      <el-table-column prop="name" label="名称"> </el-table-column>
      <el-table-column prop="short_name" label="简称"> </el-table-column>
      <el-table-column prop="owner" label="负责人"> </el-table-column>
      <el-table-column prop="mobile" label="电话"> </el-table-column>
      <el-table-column prop="email" label="邮箱"> </el-table-column>
      <el-table-column prop="address" label="地址"> </el-table-column>
      <el-table-column prop="parentName" label="父机构" width="120"> </el-table-column>
      <el-table-column prop="allowCount" label="允许子机构数量" width="130"> </el-table-column>
      <el-table-column prop="allowTag" label="允许设置子机构" width="130">
        <template slot-scope="scope">
          {{ scope.row.allowTag ? '允许' : '不允许' }}
        </template>
      </el-table-column>
      <el-table-column prop="uscc" label="社会信用代码"> </el-table-column>
      <el-table-column prop="usccFile" label="营业执照">
        <template slot-scope="scope">
          <el-button
            v-show="scope.row.usccFile"
            @click="handlePictureCardPreview(scope.row.usccFile)"
            type="text"
            size="small"
            >预览</el-button
          >
        </template>
      </el-table-column>
      <el-table-column fixed="right" label="操作" width="120">
        <template slot-scope="scope">
          <el-button @click="Edit(scope.$index)" type="text" size="small"
            >编辑</el-button
          >
          <el-button
            @click="Delete(scope.$index, scope.row)"
            type="text"
            size="small"
            >删除</el-button
          >
          <el-popover
            placement="bottom"
            trigger="click"
            popper-class="customPopper"
          >
            <div>
              <el-button
                :style="{ color: '#409eff' }"
                @click="onOpenMessage(scope.row)"
                type="text"
                size="small"
                >短信充值</el-button
              >
            </div>
            <div>
              <el-button
                :style="{ color: '#409eff' }"
                @click="onOpenRecord(scope.row)"
                type="text"
                size="small"
                >充值记录</el-button
              >
            </div>
            <div>
              <el-button
                :style="{ color: '#409eff' }"
                @click="onOpenSend(scope.row)"
                type="text"
                size="small"
                >推送权限</el-button
              >
            </div>
            <i
              :style="{ marginLeft: '12px', cursor: 'pointer' }"
              class="el-icon-more"
              slot="reference"
            ></i>
          </el-popover>
        </template>
      </el-table-column>
    </el-table>
    <div class="tableDel-Page">
      <Pagination :params="pagin" @pageBind="getList"></Pagination>
    </div>
    <el-dialog :visible.sync="dialogVisible" width="90%">
      <template>
        <iframe
          :src="dialogImageUrl"
          style="width: 100%; height: 600px; border: none"
        ></iframe>
      </template>
    </el-dialog>
    <el-dialog
      title="短信充值"
      :visible.sync="dialogMessageVisible"
      @close="closeMessageDailog"
    >
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="120px"
      >
        <el-form-item label="剩余可用短信" prop="remainingSms">
          <el-input v-model="ruleForm.remainingSms" disabled></el-input>
        </el-form-item>
        <el-form-item label="变更类型" prop="changeType">
          <el-radio-group v-model="ruleForm.changeType">
            <el-radio label="0">增加</el-radio>
            <el-radio label="1">减少</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="变更数量" prop="changeQuantity">
          <el-input v-model.number="ruleForm.changeQuantity"></el-input>
        </el-form-item>
        <el-form-item label="变更后可用短信" prop="change">
          <el-input v-model="ruleForm.change" disabled></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="submitForm('ruleForm')"
            >确定</el-button
          >
          <el-button @click="resetForm('ruleForm')">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog
      title="充值记录"
      :visible.sync="dialogTableVisible"
      width="700px"
      @close="closeDailog"
    >
      <el-form ref="seachForm" :model="seachForm" label-width="80">
        <el-row :gutter="24">
          <el-col :span="17">
            <el-form-item label="操作时间">
              <el-col :span="9">
                <el-form-item prop="startTime">
                  <el-date-picker
                    type="datetime"
                    placeholder="选择日期"
                    v-model="seachForm.startTime"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    style="width: 100%"
                  ></el-date-picker>
                </el-form-item>
              </el-col>
              <el-col class="line" :span="1">-</el-col>
              <el-col :span="9">
                <el-form-item prop="endTime">
                  <el-date-picker
                    type="datetime"
                    placeholder="选择时间"
                    v-model="seachForm.endTime"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    style="width: 100%"
                  ></el-date-picker>
                </el-form-item>
              </el-col>
            </el-form-item>
          </el-col>
          <el-col :span="7">
            <el-form-item>
              <el-button @click="resetSearchForm('seachForm')">清除</el-button>
              <el-button type="primary" @click="onSearchSubmit('seachForm')"
                >查询</el-button
              >
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <el-table :data="recordData">
        <el-table-column
          property="updateTime"
          label="操作时间"
          width="150"
        ></el-table-column>
        <el-table-column property="changeType" label="操作类型" width="120">
          <template slot-scope="scope">
            {{ scope.row.changeType === "0" ? "增加" : "减少" }}
          </template>
        </el-table-column>
        <el-table-column
          property="changeQuantity"
          label="操作数量"
          width="120"
        ></el-table-column>
        <el-table-column
          property="remainingSms"
          label="变更前短信数量"
          width="120"
        ></el-table-column>
        <el-table-column
          property="changeAfterSms"
          label="变更后短信数量"
          width="120"
        ></el-table-column>
      </el-table>
      <div class="tableDel-Page">
        <el-pagination
          :current-page="recordPagin.pageNum"
          :page-size="recordPagin.pageSize"
          layout="prev, pager, next"
          :total="recordPagin.total"
          @current-change="handleCurrentChange"
        >
        </el-pagination>
      </div>
    </el-dialog>
    <el-dialog
      title="推送权限"
      :visible.sync="dialogSendVisible"
      width="700px"
      @close="closeSendDailog"
    >
      <el-form :model="ruleSendForm" ref="ruleSendForm" label-width="100px">
        <el-form-item label="">
          <el-checkbox-group v-model="ruleSendForm.type">
            <el-checkbox label="message" name="type">短信报警</el-checkbox>
            <el-checkbox label="wechat" name="type">微信报警</el-checkbox>
            <el-checkbox label="email" name="type">email报警</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="submitRule('ruleSendForm')"
            >提交</el-button
          >
          <el-button @click="resetSendForm('ruleSendForm')">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import Pagination from "@/components/Pagination";
export default {
  name: "admin",
  data() {
    var validNum = (rule, value, callback) => {
      if (this.ruleForm.type === "减少" && +value > +this.ruleForm.overplus) {
        callback(new Error("请输入小于等于剩余可用短信"));
      } else {
        callback();
      }
    };
    return {
      name: "",
      mobile: "",
      dialogImageUrl: "",
      dialogVisible: false,
      dialogMessageVisible: false,
      dialogTableVisible: false,
      dialogSendVisible: false,
      env: this.getEnv(),
      data: [],
      rowData: {},
      privilegeData: {},
      pagin: {
        pageNum: 1,
        pageSize: 20,
        total: 0,
      },
      recordPagin: {
        pageNum: 1,
        pageSize: 10,
        total: 0,
      },
      checkArray: [], //check选中
      ruleForm: {
        remainingSms: "",
        changeType: "",
        changeQuantity: "",
        change: "",
      },
      ruleSendForm: {
        type: [],
      },
      rules: {
        changeType: { required: true, message: "请选变更类型" },
        changeQuantity: [
          { required: true, message: "请填写变更数量" },
          { type: "number", message: "变更数量必须为数字值" },
          { validator: validNum, trigger: "blur" },
        ],
      },
      recordData: [],
      seachForm: {
        startTime: "",
        endTime: "",
      },
    };
  },
  watch: {
    ruleForm: {
      handler(val) {
        if (val.changeType === "0" && !!val.changeQuantity) {
          const value = +val.remainingSms + +val.changeQuantity;
          this.ruleForm.change = value;
        }
        if (val.changeType === "1" && !!val.changeQuantity) {
          const value = +val.remainingSms - +val.changeQuantity;
          this.ruleForm.change = value;
        }
      },
      deep: true,
    },
  },
  methods: {
    handlePictureCardPreview(url) {
      (this.dialogImageUrl = url), (this.dialogVisible = true);
    },
    search() {
      //搜索
      this.pagin.pageNum = 1;
      this.getList();
    },
    getList() {
      //数据绑定
      let params = {
        pageNum: this.pagin.pageNum,
        pageSize: this.pagin.pageSize,
      };
      if (this.name.trim() != "") {
        params.name = this.name;
      }
      if (this.mobile.trim() != "") {
        params.mobile = this.mobile;
      }
      this.$http.post("/manage/institution/list", params).then((results) => {
        this.data = results["data"]["data"]["records"];
        this.pagin.total = results["data"]["data"]["total"];
      });
    },
    Edit(index) {
      this.$store.commit("setEditInfo", this.data[index]);
      this.$router.push("./edit/" + this.data[index].id);
    },
    Delete(index) {
      //单删
      if (confirm("确认要删除吗？")) {
        let ID = this.data[index].id;
        this.$http.post("/manage/institution/del", { id: ID }).then(() => {
          this.data.splice(index, 1);
        });
      }
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let params = {
            changeType: this.ruleForm.changeType,
            changeQuantity: this.ruleForm.changeQuantity,
            institutionId: this.rowData.id,
            institutionName: this.rowData.name,
          };
          this.$http
            .post(`${this.env}/ll/sms/recharge/change`, params)
            .then((results) => {
              if (results["data"]["code"] === 200) {
                this.dialogMessageVisible = false;
                this.getList();
              }
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.dialogMessageVisible = false;
    },
    onSearchSubmit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.getRecordList();
        }
      });
    },
    resetSearchForm(formName) {
      this.$refs[formName].resetFields();
    },
    getRecordList(id) {
      let params = {
        pageNum: this.recordPagin.pageNum,
        pageSize: this.recordPagin.pageSize,
        institutionId: id,
      };
      if (this.seachForm.startTime) {
        params.startTime = this.seachForm.startTime;
      }
      if (this.seachForm.endTime) {
        params.endTime = this.seachForm.endTime;
      }
      this.$http
        .get(`${this.env}/ll/sms/recharge/log/page`, {
          params,
        })
        .then((results) => {
          this.recordData = results["data"]["body"]["records"];
          this.recordPagin.total = results["data"]["body"]["total"];
        });
    },
    handleCurrentChange(val) {
      this.recordPagin.pageNum = val;
      this.getRecordList(this.rowData.id);
    },
    onOpenRecord(row) {
      this.dialogTableVisible = true;
      this.rowData = row;
      this.getRecordList(row.id);
    },
    onOpenSend(row) {
      this.dialogSendVisible = true;
      this.rowData = row;
      this.$http.get(`/manage/alert-channel/ins/${row.id}`).then((results) => {
        const val = results["data"]["data"];
        this.privilegeData = val;
        this.ruleSendForm.type = [
        val && val.email === true ? "email" : "",
        val &&  val.message === true ? "message" : "",
        val && val.wechat === true ? "wechat" : "",
        ].filter((isBoolean) => !!isBoolean);
      });
    },
    closeDailog() {
      this.dialogTableVisible = false;
      this.$refs["seachForm"].resetFields();
      this.recordPagin.pageNum = 1;
    },
    closeMessageDailog() {
      this.dialogMessageVisible = false;
      this.$refs["ruleForm"].resetFields();
    },
    closeSendDailog() {
      this.dialogSendVisible = false;
      this.$refs["ruleSendForm"].resetFields();
      this.ruleSendForm.type = [];
    },
    onOpenMessage(row) {
      this.dialogMessageVisible = true;
      this.rowData = row;
      this.$http
        .get(`${this.env}/ll/sms/recharge/${row.id}`)
        .then((results) => {
          this.ruleForm.remainingSms =
            (results["data"]["body"] &&
              results["data"]["body"]["remainingSms"]) ||
            0;
        });
    },
    getEnv() {
      if (location.host == "localhost:8080") {
        return "https://dev.network.baitengfa.com";
      } else if (location.host == "dev.iotmanage.baitengfa.com") {
        return "https://dev.network.baitengfa.com";
      } else if (location.host == "iotmanage.baitengfa.com") {
        return "https://iot.network.baitengfa.com";
      }
    },
    resetSendForm(formName) {
      this.$refs[formName].resetFields();
      this.dialogSendVisible = false;
      this.ruleSendForm.type = [];
    },
    submitRule(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let params = {
            institution_id: this.rowData.id,
            message:
              this.ruleSendForm.type.findIndex((i) => i === "message") > -1
                ? true
                : false,
            email:
              this.ruleSendForm.type.findIndex((i) => i === "email") > -1
                ? true
                : false,
            wechat:
              this.ruleSendForm.type.findIndex((i) => i === "wechat") > -1
                ? true
                : false,
          };
          if (this.privilegeData && this.privilegeData.id) {
            params.id = this.privilegeData.id;
          }

          this.$http
            .post("/manage/alert-channel/saveOrUpdate", params)
            .then((rs) => {
              if (rs.data.code == 0) {
                this.$refs["ruleSendForm"].resetFields();
                this.dialogSendVisible = false;
                this.ruleSendForm.type = [];
                this.$message({
                  message: "操作成功",
                  type: "success",
                });
              } else {
                this.$message({
                  message: rs.data.message,
                  type: "error",
                });
              }
            });
        }
      });
    },
  },
  components: { Pagination },
};
</script>
<style>
.customPopper {
  min-width: 60px !important;
}
.line {
  text-align: center;
}
</style>